
import moreCalendarMixin from '../Mixins/moreCalendarMixin'; // JS2TS: was the absolute ambient-module path; moreCalendarMixin is now a real TS module, imported relatively.
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './moreCoreCalendar.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import stamp from 'dojo/date/stamp';
import aspect from 'dojo/aspect';
import domGeom from 'dojo/dom-geometry';
import query from 'dojo/query';
import date from 'dojo/date';
import arr from 'dojo/_base/array';

import domStyle from 'dojo/dom-style';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import Observable from 'dojo/store/Observable';
import Memory from 'dojo/store/Memory';
//import Calendar_Buttons = require("../Calendar_Buttons/Calendar_Buttons");
//import "../Calendar_Buttons/Calendar_Buttons";
import moreCoreVerticalRenderer from '../Renderers/moreCoreVerticalRenderer';
import "../Renderers/moreCoreVerticalRenderer";
import "../Renderers/moreCoreHorizontalRenderer";
import "../Renderers/moreCoreLabelRenderer";
import Toaster from '../../Toaster_TS/Toaster';
import "../../Toaster_TS/Toaster";
import GenericDialog from '../../GenericDialog/GenericDialog';
import "../../GenericDialog/GenericDialog";
import { WebcalendarTypes } from '../WebCalendarTypes';
import methodHooks from 'more/mdsMethodHooks';





interface calendarData { items: Array<moreCoreCalendarItem>, mode?: string, displayDate?: string, DataGroupValues?: Array<string> }

interface moreCoreCalendarItem {
    id: string;
    startTime: string;
    endTime: string;
    allDay: boolean;
    editable: boolean;
    Classname?: string;
    moveEnabled?: boolean;
    resizeEnabled?: boolean;
    Default_BackColor?: string;
    Default_TextColor?: string;
    coloration?: Array<any>;
    calendar?: string;
}

interface params {
    start: string,
    end: string,
    mode: string,
    steps: number
}
class moreCoreCalendar extends methodHooks(compose(moreCalendarMixin)) {
    templateString: any = template;

    //// nodes -------------------------------------------------------START
    mainContainer: HTMLElement;
    //calendarButtons: Calendar_Buttons;
    viewContainer: HTMLElement;
    //// nodes -------------------------------------------------------END
    //// Properties ------------------------------------------------------START
    toaster: MdsLax<InstanceType<typeof Toaster>>;
    verticalRenderer: MdsLax<InstanceType<typeof moreCoreVerticalRenderer>>;
    summaryAttr: string = "barview_text";

    minDateAllowed: Date;
    maxDateAllowed: Date;
    minRangeExceeded: boolean;
    maxRangeExceeded: boolean;

    lastDataSet: string;
    store: any = null;
    baseStore: any = null;
    data: calendarData = null;
    params: params = null;
    _isEditingEnabled: boolean = false;

    refreshDisplayTimeout: number = null;
    decreaseArrowNode: Array<any> = [];
    isEditingLocked: boolean = true;
    scrollTimeout: number;
    invalidateTimeout: number;

    showEndtime: boolean = false;
    hideColumnHead: boolean = true;
    showDivSubGroup: boolean = true;

    columnView_bodyText_attribute: string;
    columnView_headText_attribute: string;

    maxVisibleHours: number = 15; // vieviele stunden range ist sichtbar

    dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    isHourResizeEnabled: boolean = true;
    fallbackcolor: string = "#940000";

    allDayTimeout: number = null;
    allDayMode: boolean = true;

    itemToHighlight_ID: string = null;
    lastHighlightedCalendarItem_ID: string = null;

    itemOverlapPercentage: number = 50; // int, default


    itemColorationAttribute: any = []; // nach welchem Attribut die Items gef�rbt sein sollen

    private calendarConfig: WebcalendarTypes.calendarConfig = { // DEFAULT CALENDAR CONFIG
        columnView: {
            firstDayOfWeek: 1, // 1 f�r montag 
            minHours: 0, // The first hour displayed by the main sheet,
            maxHours: 24, //The last hour displayed (excluded),
            selectionMode: "single", // controls the selection, this property can take the following values: �none� - no selection is possible | �single� - only one item can be selected at most | "multiple� - zero or several items can be selected.
            columnHeaderDatePattern: "EEE dd.MM.yyyy"
        },
        matrixView: {
            labelRendererHeight: 17
        }

    };

    
    itemClickFunction: Function;

    /*= function (item: any) { // Default
        console.log("itemClick?")

        if (this.dlg != null) {
            if (this.dlg.modalDlgNode) this.dlg.close();
            this.dlg = null;
        }

        this.dlg = new GenericDialog();

        this.dlg.set("header", item[this.columnView_headText_attribute]);
        this.dlg.set("content", item[this.columnView_bodyText_attribute]);
        this.dlg.set("closeBtn", true);

        this.dlg.show();

    }
    */

    

    //// Properties ------------------------------------------------------END

    setFallbackcolor(value: string): void {
        this.fallbackcolor = value;
        topic.publish("moreCoreCalendar/setFallbackcolor", value);
    }

    

    setColumnView_bodyText_attribute(value: string): void {
        this.columnView_bodyText_attribute = value;
        topic.publish("moreCoreCalendar/setColumnBodyText", value);

    }

    setColumnView_headText_attribute(value: string): void {
        this.columnView_headText_attribute = value;
        topic.publish("moreCoreCalendar/setColumnHeadText", value);

    }

    // configure, to which precentage elements may superpose over each other if they are overlapping in time
    setItemsOverlapPercentage(intPercentage: number): void {
        this.itemOverlapPercentage = intPercentage;
        if (this.columnView) {
            this.columnView.set('percentOverlap', this.itemOverlapPercentage);
            this._refreshItemsRendering();
        }
    }
    _setItemsOverlapPercentageAttr(intPercentage: number): void {
        this.setItemsOverlapPercentage(intPercentage);
    }

    private _bShowDataGrouping: boolean = false;
    private _bShowEmptySubColumns: boolean = false;
    showSubColumns(showDataGrouping: boolean, showEmptySubColumns: boolean = false) {
        if (showDataGrouping == false) {
            this.columnView.set("subColumns", null);
        } else {
            if (!this.calendarConfig?.columnView?.groups?.length) {
                this.columnView.set("subColumns", null);
            } else {
                if (showEmptySubColumns) {
                    //console.log("showEmptySubColumns")
                    this.columnView.set("subColumns", this.calendarConfig.columnView.groups);
                } else {
                    let filledGroups = this._getFilledGroups();

                    this.columnView.set("subColumns", filledGroups);
                }
            }
        }
        if (this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") this.columnView.invalidateRendering();

        this._bShowDataGrouping = showDataGrouping;
        this._bShowEmptySubColumns = showEmptySubColumns;
    }

    setAutoAdjust(bool: boolean = false) {
        if (bool == false) {
            this.columnView.set("rowHeaderLabelSlotDuration", 30);
            this.columnView.set('hourSize', 70);
            return;
        }

        let mbox = domGeom.getMarginBox(this.columnView.scrollContainer);
        let scrollContainerHeight = mbox.h;
        let maxVisibleHours = 15;


        if (scrollContainerHeight < 550) {
            this.columnView.set("rowHeaderLabelSlotDuration", 60);
        } else {
            this.columnView.set("rowHeaderLabelSlotDuration", 30);
        }

        if (scrollContainerHeight >= 300) {
            var hourSize = scrollContainerHeight / maxVisibleHours;

            //console.log("scrollContainerHeight: ", scrollContainerHeight, "maxVisibleHours: ", maxVisibleHours, "hourSize: ", hourSize);

            this.columnView.set('hourSize', hourSize);
        } else {
            // bei kleineren ansichten als 300px, fix auf 20px setzen
            this.columnView.set('hourSize', 20);
        }
    }

  
    showTimeIndicator(bool: boolean = true) {
        this.columnView.set("showTimeIndicator", bool);
    }

    /*
    setShowEndTime(bool: boolean = false, skipItemRendering?: boolean): void {

        topic.publish("MainProperties/cbShowEndTime_checked", bool);
        if (skipItemRendering !== true) {
            this._refreshItemsRendering();
        }
    }
    */

    setHideColumHeadIfNeeded(bool: boolean = false, skipItemRendering?: boolean): void {

        topic.publish("MainProperties/cbHideColumHeadIfNeeded_checked", bool);
        if (skipItemRendering !== true) {
            //this._refreshItemsRendering();
        }
    }

    configureCalendar(calendarConfig?: WebcalendarTypes.calendarConfig): void {
        if (calendarConfig) this.calendarConfig = calendarConfig;

        if (this.calendarConfig) {
            //this.todayButtonClick();
            //this.weekButtonClick();

            this.set("firstDayOfWeek", this.calendarConfig.columnView.firstDayOfWeek);
            this.columnView.set('minHours', this.calendarConfig.columnView.minHours);
            this.columnView.set('maxHours', this.calendarConfig.columnView.maxHours);
            this.columnView.set('percentOverlap', this.itemOverlapPercentage);
            this.columnView.set('selectionMode', this.calendarConfig.columnView.selectionMode);
            this.columnView.set("columnHeaderDatePattern", this.calendarConfig.columnView.columnHeaderDatePattern);
            this.matrixView.set('labelRendererHeight', this.calendarConfig.matrixView.labelRendererHeight);
 
        }

        arr.forEach([this.matrixView.labelRenderer, this.matrixView.horizontalRenderer, this.monthColumnView.verticalRenderer, this.columnView.verticalRenderer], lang.hitch(this, function (renderer) {
            lang.extend(renderer, {
                getItemColor: lang.hitch(this, function (item: any) {
                    var result;
                    if (item.bOverrideColoration == true) {
                        result = { backColor: item.Default_BackColor, textColor: item.Default_TextColor };
                    } else {
                        if (item.coloration && item.coloration.length) {
                            for (var i = 0; i < item.coloration.length; i++) {
                                var color: { ID: string, Classname: string, ComplexAttributeName: string, BackColor: string, TextColor: string } = item.coloration[i];

                                if (this.itemColorationAttribute[color.Classname] && color.ID == this.itemColorationAttribute[color.Classname]) {
                                    result = { backColor: color.BackColor, textColor: color.TextColor };
                                }

                                /*
                                // 1) die attr muss zutreffen, 2) this.itemColorationAttribute == nach welchem Attribut die Items gef�rbt sein sollen
                                if (item.Classname == color.Classname && this.itemColorationAttribute) {
                                    if (this.itemColorationAttribute.length == 17 && this.itemColorationAttribute.indexOf(":") == 8 && color.ID == this.itemColorationAttribute) { // wenn das eine ID ist, die zutrifft
                                        console.log("p2", color);
                                        result = { backColor: color.BackColor, textColor: color.TextColor };
                                    } else if (color.ComplexAttributeName == this.itemColorationAttribute) { //es ist ein ComplexAttributeName, der zutrifft
                                        console.log("p3", color)
                                        result = { backColor: color.BackColor, textColor: color.TextColor };
                                    }

                                }
                                */
                            }
                        } else {
                            if (item.Default_BackColor && item.Default_TextColor) {
                                result = { backColor: item.Default_BackColor, textColor: item.Default_TextColor };
                            } else {
                                result = { backColor: this.fallbackcolor, textColor: "#000000" }; // default
                            }
                        }
                    }

                    if (this.itemToHighlight_ID && this.itemToHighlight_ID.length) {

                        if (this.itemToHighlight_ID != item.id) {

                            //// hex opacity table: https://davidwalsh.name/hex-opacity

                            var backColor: string = result.backColor;
                            var textColor: string = result.textColor;

                            result.backColor = this.setOpacityHex(backColor, "26"); // opacity value 20
                            result.textColor = this.setOpacityHex(textColor, "4D"); // opacity value 30

                        }
                    } 

                    //NEW LH

                    /*
                    if (this.calendarConfig.columnView.groupValue && item[this.calendarConfig.columnView.groupValue]) {
                        console.log("doCalendar?", result, this.calendarConfig.columnView.groupValue, item[this.calendarConfig.columnView.groupValue])
                        result["calendar"] = item[this.calendarConfig.columnView.groupValue]
                    }
                    */

                    if (!result) {
                        result = { backColor: item.Default_BackColor, textColor: item.Default_TextColor };
                    }

                    return result;
                })
            });
        }));

        /*
        this.on("timeIntervalChange", lang.hitch(this, function (args) {


            if (this.minDateAllowed && args.endTime < this.minDateAllowed) {
                alert("min range exceeded");
                this.minRangeExceeded = true;
                this._setCalendarButtonsStyle();
            } else {
                this.minRangeExceeded = false;
                this._setCalendarButtonsStyle();
            }
            if (this.maxDateAllowed && args.startTime > this.maxDateAllowed) {
                alert("max range exceeded");
                this.maxRangeExceeded = true;
                this._setCalendarButtonsStyle();
            } else {
                this.maxRangeExceeded = false;
                this._setCalendarButtonsStyle();
            }
            //console.log("onTimeIntervalChange", args);
            //                        args.startTime
            //                        args.endTime
            //                        args.oldStartTime
            //                        args.oldEndTime

            topic.publish("moreCoreCalendar/timeIntervalChange", this);
            
        }));
        */


        aspect.after(this.columnView, "invalidateRendering", lang.hitch(this, function () {

            //this.scrollToFirstVisibleItem(lang.clone(this.storeManager.items));
            this.resizeColumnViewHours();
            this.scrollToFirstVisibleItem(lang.clone(this.storeManager.items));

        }));

        this.on("itemClick", lang.hitch(this, function (eventArgs) {
            if (typeof (this.itemClickFunction) == "undefined") {
                this.setDefaultItemClickFunction();
            }
            this.itemClickFunction(eventArgs.item);
        }));

        // wenn die instanziierung und die configuration oder setData zu nah aneinander liegen, ist die currentview noch nicht da, also warten wir etwas
        if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") {
            this.columnView.secondarySheet._buildRowHeader = this.__matrixViewOverride_buildRowHeader; // secondary sheet override
            this.columnView.invalidateRendering();
        } else {
            if (this._resizeTimeout) {
                clearTimeout(this._resizeTimeout);
            }
            this.invalidateTimeout = setTimeout(lang.hitch(this, function () {

                if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") {
                    this.columnView.secondarySheet._buildRowHeader = this.__matrixViewOverride_buildRowHeader; // secondary sheet override
                    this.columnView.invalidateRendering();
                } 
            }), 100);
        }
    }

    setOpacityHex(color: string, opacityHex: string): string {

        //// "#" + 6 characters color + 2 characters opacity

        var result: string = "";

        if (/^#?[0-9A-F]{6}$/i.test(color) || /^#?[0-9A-F]{8}$/i.test(color)) { // is it a hex color?

            if (color.trim().indexOf("#") == -1) {
                color = "#" + color;
            }

            if (color.length == 7) {
                result = color + opacityHex;
            } else if (color.length == 9) {
                result = color.slice(0, 7) + opacityHex;
            } else {
                console.log("not a valid HEX color");
            }

        } else {
            console.log("please use hex colors")
        }

        return result;
    } 

    setItemToHighlight(itemID: string):void {

        if (itemID) {
            this.itemToHighlight_ID = itemID;
        }
        
        if ( this.storeManager.items) this._refreshItemsRendering();
    }

    disableHighlighting(): void {
        this.lastHighlightedCalendarItem_ID = <string>this.itemToHighlight_ID;
        this.itemToHighlight_ID = null;

        this._refreshItemsRendering();
    }

    setAllDayMode(bMode: boolean): void {
        //console.log("setAllDayMode", bMode);

        this.allDayMode = bMode;
       

        if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") {
            if (this.allDayTimeout) {
                clearTimeout(this.allDayTimeout);
            }

            this.allDayTimeout = setTimeout(lang.hitch(this, function () {
                
                if (bMode == false) {
                    this.columnView.resizeSecondarySheet(2);
                    domStyle.set(this.columnView.secondarySheet.domNode, "display", "none");
                } else {
                    
                    this.columnView.resizeSecondarySheet(this.columnView.secondarySheet._defaultHeight);
                    domStyle.set(this.columnView.secondarySheet.domNode, "display", "block");

                }

                if (this.lastDataSet) {
                    this.setData(JSON.parse(this.lastDataSet));
                }
                
            }), 100);

        }

        
    }
    _setAllDayModeAttr(bMode : boolean):void {
        this.setAllDayMode(bMode);
    }

    _setDataAttr(data: calendarData): void {
        this.setData(data);
    }
    setData(calendarData: calendarData | string) {

        this.data = null;
        if (calendarData) this.lastDataSet = null;

        this.baseStore = null;
        this.store = null;

        var data: calendarData;

        for (let item of calendarData["items"]) {
            if (this.calendarConfig.columnView.groupValue) {
                item["calendar"] = item[this.calendarConfig.columnView.groupValue];
            }
        }


        if (this.isJSON(calendarData)) {
            this.lastDataSet = <string>calendarData;
            data = JSON.parse(<string>calendarData);
        } else if (calendarData["Exception"] == true) {
            alert("ERROR: details in the console")
        } else {
            data = <calendarData>calendarData;
            this.lastDataSet = JSON.stringify(data);
        }

        if (this.allDayMode == false) {
            for (let dataItem of data.items) {
                if (dataItem["allDay"] == true) dataItem["allDay"] = false
            }
        } 

        
        this.data = data;
        if (this.data.mode) this.set("dateInterval", this.data.mode);
        if (this.data.displayDate) this.set("date", new Date(this.data.displayDate));

        if (data.DataGroupValues) {
            this.calendarConfig.columnView.groups = data.DataGroupValues;
        }

        this.baseStore = new Memory({ data: data });

        this.store = new Observable(this.baseStore);

        //console.log("store::: ", this.store.data)
        this.set("store", this.store);

        

        // wenn die instanziierung und die configuration oder setData zu nah aneinander liegen, ist die currentview noch nicht da, also warten wir etwas
        if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") {
            this.columnView.invalidateRendering();
        } else {
            if (this._resizeTimeout) {
                clearTimeout(this._resizeTimeout);
            }
            this.invalidateTimeout = setTimeout(lang.hitch(this, function () { if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") this.columnView.invalidateRendering() }), 100);
        }
        
        this._refreshItemsRendering();

        this.showSubColumns(this._bShowDataGrouping, this._bShowEmptySubColumns);
    }

    isJSON(text) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    }

    setShowEndtime(bool?: boolean): void {
        if (bool === true || bool === false) {
            this.showEndtime = bool;
        }
        topic.publish("moreCoreCalendar/bShowEndTime", this.showEndtime);
        this._refreshItemsRendering();
    }

    setHideColumnHead(bool?: boolean): void {
        if (bool === true || bool === false) {
            this.hideColumnHead = bool;
        }
        topic.publish("moreCoreCalendar/bHideColumHeadIfNeeded", this.hideColumnHead);
        this._refreshItemsRendering();
    }

    __matrixViewOverride_buildRowHeader(renderData, oldRenderData) {

        // summary:
        //		Creates incrementally the HTML structure of the row header and configures its content.			
        //
        // renderData:
        //		The render data to display.
        //
        // oldRenderData:
        //		The previously render data displayed, if any.
        // tags:
        //		private

        var rowHeaderTable = this.rowHeaderTable;

        if (!rowHeaderTable) {
            return;
        }

        var tbodies = query("tbody", rowHeaderTable);
        var tbody, tr, td;

        if (tbodies.length == 1) {
            tbody = tbodies[0];
        } else {
            tbody = domConstruct.create("tbody", null, rowHeaderTable);
        }

        var count = renderData.rowCount - (oldRenderData ? oldRenderData.rowCount : 0);

        // Build HTML structure 
        if (count > 0) { // creation
            for (var i = 0; i < count; i++) {
                tr = domConstruct.create("tr", null, tbody);
                td = domConstruct.create("td", null, tr);

                var h = [];

                h.push(on(td, "click", lang.hitch(this, this._rowHeaderClick)));

                if ("ontouchstart" in document.documentElement) {
                    console.log("ontouchstart in document.documentElement");
                } else {
                    h.push(on(td, "mousedown", function (e) {
                        domClass.add(e.currentTarget, "Active");
                    }));

                    h.push(on(td, "mouseup", function (e) {
                        domClass.remove(e.currentTarget, "Active");
                    }));

                    h.push(on(td, "mouseover", function (e) {
                        domClass.add(e.currentTarget, "Hover");
                    }));

                    h.push(on(td, "mouseout", function (e) {
                        domClass.remove(e.currentTarget, "Hover");
                    }));
                }
                this._rowHeaderHandles.push(h);
            }
        } else {
            count = -count;
            // deletion of existing nodes
            for (var i = 0; i < count; i++) {
                tbody.removeChild(tbody.lastChild);
                var list = this._rowHeaderHandles.pop();
                while (list.length > 0) {
                    list.pop().remove();
                }
            }
        }

        // fill labels

        query("tr", rowHeaderTable).forEach(function (tr, i, arr) {

            if (arr.length <= renderData.dates.length) {
                domStyle.set(<any>tr, "height", this._getRowHeight(i) + "px");

                if (renderData.dates && renderData.dates[i]) {
                    var d = renderData.dates[i][0];

                    var td: HTMLTableDataCellElement = <HTMLTableDataCellElement>query("td", tr)[0];
                    td.className = "";
                    if (i == 0) {
                        domClass.add(td, "first-child");
                    }
                    if (i == this.renderData.rowCount - 1) {
                        domClass.add(td, "last-child");
                    }

                    this.styleRowHeaderCell(td, d, renderData);

                    this._setText(td, this._formatRowHeaderLabel(d));
                }
            }

        }, this);

    }

    scrollToFirstVisibleItem(items: Array<any>): void {
        if (items && items.length) {

            // zum ersten item scrollen
            var firstTitemOfVisibleRange: { startTime: Date } = this.getFirstItemOfCurrentVisibleRange(items);
            if (firstTitemOfVisibleRange != null) {
                this.currentView.set("startTimeOfDay", { hours: firstTitemOfVisibleRange.startTime.getHours(), duration: 1000 });
            } else {
                // wenn items vorhanden sind, aber keines anzuzeigen ist, dann zu 08:00 scrollen
                this.currentView.set("startTimeOfDay", { hours: 8, duration: 1000 });
            }

        } else {
            // wenn keine items vorhanden sind, dann zu 08:00 scrollen
            this.currentView.set("startTimeOfDay", { hours: 8, duration: 1000 });
        }
    }

    _setDefaultViewAttr(sDefaultView: string): void {

        var sExpectedDateInterval: string = "week";
        var iExpectedDateIntervalSteps: number = 1;

        switch (sDefaultView) {
            case "WEEK":
            case "MONTH":
            case "DAY":
                sExpectedDateInterval = sDefaultView.toLowerCase();
                iExpectedDateIntervalSteps = 1;
                break;
            case "THREEDAYS":
                sExpectedDateInterval = "day";
                iExpectedDateIntervalSteps = 3;
                break;
            case "TWOWEEKS":
                sExpectedDateInterval = "week";
                iExpectedDateIntervalSteps = 2;
                break;
        }

        if (sExpectedDateInterval != this.get("dateInterval")) {
            this.set("dateInterval", sExpectedDateInterval);
        }

        if (iExpectedDateIntervalSteps != this.get("dateIntervalSteps")) {
            this.set("dateIntervalSteps", iExpectedDateIntervalSteps);
        }


    }


    isItemEditable(item, rendererKind) {

        // diese Konstellation ist f�r touch editing gebraucht, da das item eine andere struktur beim touch hat

        if (item && item.editable === true && !this.isEditingLocked) {
            return true
        } else if (item && item._item && item._item.editable === true && !this.isEditingLocked) {
            return true
        }

        return false;
    }

    isItemResizeEnabled(item, rendererKind) {
        return this.isItemEditable(item, rendererKind) && item.resizeEnabled;
    }

    isItemMoveEnabled(item, rendererKind) {
        return this.isItemEditable(item, rendererKind) && item.moveEnabled;
    }

    decodeDate(s) {
        return stamp.fromISOString(s);
    }

    encodeDate(d) {
        return stamp.toISOString(d);
    }

    _hideSubColumns(bool: boolean): void {
        this.columnView.set("subColumns", null)
    }

    refreshTimeIndicator(value: boolean) {
        this.columnView.set("showTimeIndicator", value);
    }

    _showEntity(entity: object): void {
        this.set("date", new Date(entity["startTime"]));
    }

    resizeColumnViewHours() {

        if (!this.columnView.renderData) {
            return;
        }

        var startTime = this.currentView.get("startTimeOfDay");
        if (this.isHourResizeEnabled) {
            var mbox = domGeom.getMarginBox(this.columnView.scrollContainer);


            var scrollContainerHeight = mbox.h;
            var maxVisibleHours = this.maxVisibleHours;

            if (scrollContainerHeight < 550) {
                this.columnView.set("rowHeaderLabelSlotDuration", 60);
            } else {
                this.columnView.set("rowHeaderLabelSlotDuration", 30);
            }

            if (scrollContainerHeight >= 300) {
                var hourSize = scrollContainerHeight / maxVisibleHours;

                this.columnView.set('hourSize', hourSize);
            } else {
                // bei kleineren ansichten als 300px, fix auf 20px setzen
                this.columnView.set('hourSize', 20);
            }
        }

        this.currentView.set("startTimeOfDay", startTime);

        if (this._resizeTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(lang.hitch(this, function () { this.scrollToFirstVisibleItem(lang.clone(this.storeManager.items)) }), 100);
        
    }

    onItemEditEndGesture(e) {

        topic.publish("itemEitGesture_end", e);

        // this below would set back the start- && endTime of the item to the state before editing, while the editing itself is enabled
        //e.item.startTime = e.source._editStartTimeSave;
        //e.item.endTime = e.source._editEndTimeSave;

        if ("ontouchstart" in document.documentElement) {
            console.log("Callback for refreshing");
            this._updateRendering();

        }
    }

    setMaxVisibleHours(value: number): void {
        if (value > 2) {
            this.maxVisibleHours = value;
        } else {
            this.maxVisibleHours = 15; // damit keine sinnlosigkeit entsteht
        }

        // wenn die instanziierung und die configuration oder setData zu nah aneinander liegen, ist die currentview noch nicht da, also warten wir etwas
        if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") {
            this.columnView.invalidateRendering();
        } 
    }

    setIsHourResizeEnabled(bool: boolean): void {
        this.isHourResizeEnabled = bool;

        // wenn die instanziierung und die configuration oder setData zu nah aneinander liegen, ist die currentview noch nicht da, also warten wir etwas
        if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") {
            this.columnView.invalidateRendering();
        } else {
            if (this._resizeTimeout) {
                clearTimeout(this._resizeTimeout);
            }
            this.invalidateTimeout = setTimeout(lang.hitch(this, function () { if (this.currentView && this.currentView.domNode.classList[0] == "dojoxCalendarColumnView") this.columnView.invalidateRendering() }), 100);
        }
    }

    _setIsHourResizeEnabledAttr(bool: boolean): void {
        this.setIsHourResizeEnabled(bool);
    }

    _setMaxVisibleHoursAttr(value: number): void {
        this.setMaxVisibleHours(value);
    }

    _updateRendering() {
        if (this.verticalRenderer) {
            this.verticalRenderer.updateRendering()
        }
    }

    _computeCurrentView(startDate, endDate, duration) {
        // show the month column view if the duration is greater than 31x2 days
        if (duration > 62) {
            return this.monthColumnView;
        } else {
            return super._computeCurrentView.apply(this, arguments as any);
        }
    }

    _configureView(view, index, timeInterval, duration) {
        // quartalsansicht steuern
        if (view.viewKind == "monthColumns") {
            var m = timeInterval[0].getMonth();
            var d = this.newDate(timeInterval[0]);
            d.setMonth(m < 4 ? 0 : 4);
            view.set("startDate", d);
            view.set("columnCount", 4);
        } else {
            return super._configureView.apply(this, arguments as any);
        }
    }

    setDefaultItemClickFunction() {
        this.itemClickFunction = function (item: any) { // Default

            if (this.dlg != null) {
                if (this.dlg.modalDlgNode) this.dlg.close();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();

            this.dlg.set("header", item[this.columnView_headText_attribute]);
            this.dlg.set("content", item[this.columnView_bodyText_attribute]);
            this.dlg.set("closeBtn", true);

            this.dlg.show();
        }
    }

    
    /* NEW, need to be array now
    _setItemColorationAttributeAttr(identifier: string): void { // kann ine ID oder ComplexAttributeName sein
        this.setItemColorationAttribute(identifier);
    }
    setItemColorationAttribute(identifier: string): void {
        //this.itemColorationAttribute = identifier;
    }
    */

    /*
     _placeCalendarButtons(targetNode: HTMLElement): void {
        if (targetNode) {
            this.calendarButtons.placeAt(targetNode);
        }
    }
      
     
     _setAllowedViewsAttr(bDayView: boolean, bWeekView: boolean, bMonthView: boolean, bThreeDaysView: boolean, bTwoWeeksView: boolean): void {

        if (!bDayView) {
            domStyle.set(this.calendarButtons.dayButton, "display", "none");
            domStyle.set(this.calendarButtons.todayButton, "display", "none");
        } else {
            domStyle.set(this.calendarButtons.dayButton, "display", "inline-block");
            domStyle.set(this.calendarButtons.todayButton, "display", "inline-block");
        }

        if (!bWeekView) {
            domStyle.set(this.calendarButtons.weekButton, "display", "none");
        } else {
            domStyle.set(this.calendarButtons.weekButton, "display", "inline-block");
        }
        if (!bMonthView) {
            domStyle.set(this.calendarButtons.monthButton, "display", "none");
        } else {
            domStyle.set(this.calendarButtons.monthButton, "display", "inline-block");
        }
        if (!bThreeDaysView) {
            domStyle.set(this.calendarButtons.threeDaysButton, "display", "none");
        } else {
            domStyle.set(this.calendarButtons.threeDaysButton, "display", "inline-block");
        }
        if (!bTwoWeeksView) {
            domStyle.set(this.calendarButtons.twoWeekButton, "display", "none");
        } else {
            domStyle.set(this.calendarButtons.twoWeekButton, "display", "inline-block");
        }

        //this.calendarButtons.modeSelect
    }
     
     _setCalendarButtonsStyle(): void {
        if (this.minRangeExceeded === true) {
            domAttr.set(this.calendarButtons.previousButton, "disabled", true);
        } else {
            domAttr.remove(this.calendarButtons.previousButton, "disabled");
        }

        if (this.maxRangeExceeded === true) {
            domAttr.set(this.calendarButtons.nextButton, "disabled", true);
        } else {
            domAttr.remove(this.calendarButtons.nextButton, "disabled");
        }
    }
     
     showCalendarButtons(bool: boolean): void {
        if (bool) {
            this.calendarButtons = new Calendar_Buttons();
            this.configureButtons();
            let topBar_item_right = document.getElementById("mainMenuGlobalSpace");
            this.calendarButtons.placeAt(topBar_item_right);
            domClass.remove(this.calendarButtons.domNode, "w3-hide");
        } else {
            domClass.add(this.calendarButtons.domNode, "w3-hide");
        }

    }

    configureButtons() {

        if (this.calendarButtons) {
            var rtl = !this.isLeftToRight();

            if (this.calendarButtons.previousButton) {
                this.own(
                    on(this.calendarButtons.previousButton, "click", lang.hitch(this, function () {
                        this.previousRange();
                    }))
                    
                );
            }

            if (this.calendarButtons.nextButton) {
                //this.nextButton.set("label", _nls[rtl ? "previousButton" : "nextButton"]);
                this.own(
                    on(this.calendarButtons.nextButton, "click", lang.hitch(this, function () {
                        this.nextRange();
                    } ))
                );
            }

            if (rtl && this.calendarButtons.previousButton && this.calendarButtons.nextButton) {
                var t = this.calendarButtons.previousButton;
                this.calendarButtons.previousButton = this.calendarButtons.nextButton;
                this.calendarButtons.nextButton = t;
            }

            if (this.calendarButtons.todayButton) {
                //this.todayButton.set("label", _nls.todayButton);
                this.own(
                    on(this.calendarButtons.todayButton, "click", lang.hitch(this, function () {
                        this.todayButtonClick();
                    }))
                );
            }

            if (this.calendarButtons.dayButton) {
                //this.dayButton.set("label", _nls.dayButton);
                this.own(
                    on(this.calendarButtons.dayButton, "click", lang.hitch(this, function () {
                        this.dayButtonClick();
                    } ))
                );
            }

            if (this.calendarButtons.weekButton) {
                //this.weekButton.set("label", _nls.weekButton);
                this.own(
                    on(this.calendarButtons.weekButton, "click", lang.hitch(this, function () {
                        this.weekButtonClick();
                    } ))
                );
            }

            if (this.calendarButtons.monthButton) {
                //this.monthButton.set("label", _nls.monthButton);
                this.own(
                    on(this.calendarButtons.monthButton, "click", lang.hitch(this, function () {
                        this.monthButtonClick();
                    }))
                );
            }

            if (this.calendarButtons.twoWeekButton) {
                // should set label from resource bundle here!
                this.own(
                    on(this.calendarButtons.twoWeekButton, "click", lang.hitch(this, function () {
                        this.set("dateIntervalSteps", 2);
                        this.set("dateInterval", "week");
                    }))
                );
            }
            if (this.calendarButtons.threeDaysButton) {
                // should set label from resource bundle here!
                this.own(
                    on(this.calendarButtons.threeDaysButton, "click", lang.hitch(this, function () {
                        this.set("dateIntervalSteps", 3);
                        this.set("dateInterval", "day");
                    }))
                );
            }
        }
        
    }

showButton(name: string, show: boolean): void {
        if (name && this.calendarButtons[name]) {
            if (show === false) {
                domClass.add(this.calendarButtons[name], "w3-hide");
            } else {
                domClass.remove(this.calendarButtons[name], "w3-hide");
            }
        }
    }
    */



    // 
    setDate(date: Date | string): void {
        //ISO String works

        if (typeof date == "string") {
            this.set("date", this.floorToDay(new Date(date), true));
        } else if (Object.prototype.toString.call(date) === "[object Date]") {
            if (!isNaN(date.getFullYear())) {
                this.set("date", this.floorToDay(date, true));
            } 
        } 


    }

    getFirstItemOfCurrentVisibleRange(items) {
        var rangeStart = this._timeInterval[0];
        var rangeEnd = this._timeInterval[1];

        // sortieren nach startzeit
        items.sort(this.sortItemsByDateHours);

        // nur items zulassen die auch angezeigt werden, nicht bei 0:00 beginnen und an diesem tag beginnen
        var itemsInRange = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i];

            if (
                (item.startTime >= rangeStart && item.startTime <= rangeEnd)
                && item.startTime.getHours() > 0) {
                itemsInRange.push(item);
            }
        }

        if (itemsInRange.length > 0) {
            return itemsInRange[0];
        }

        return null;
    }

    sortItemsByDateHours(a, b) {

        if (a.startTime.getHours() < b.startTime.getHours())
            return -1;
        if (a.startTime.getHours() > b.startTime.getHours())
            return 1;
        return 0;

    }

    _setShowEndtimeAttr(bool: boolean): void {
        this.setShowEndtime(bool);
    }

    _setShowColumnHeadAttr(bool: boolean): void {
        this.setHideColumnHead(bool);
    }

    setSummaryAttribute(value: string): void {
        this.summaryAttr = value;
    }

    setItemClickFunction(method: Function): void {
        this.itemClickFunction = method;
    }

    setMinDateAllowed(date: Date): void {
        this.minDateAllowed = date;
    }
    setMaxDateAllowed(date: Date): void {
        this.maxDateAllowed = date;
    }

    showCalendarButtons(bool?) {

    }

    /*
    toStringISO(date: Date): string {

        if (date && Object.prototype.toString.call(date) === "[object Date]") {

            if (isNaN(date.getFullYear())) {
                return null;
            }

            let day = ("0" + date.getDate()).slice(-2); //DD
            let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
            let year = date.getFullYear() //YYYY
            let hours = ("0" + date.getHours()).slice(-2); // HH
            let min = ("0" + date.getMinutes()).slice(-2);  // mm
            let sec = ("0" + date.getSeconds()).slice(-2); // ss

            // YYYY-MM-DDTHH:mm:ss
            let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
            return ISOString;
        }

        return null;
    }
    */

    _getFilledGroups() {
        let groupLabels = []
        let otherGroupsTitle: string = "div.";
        let addOtherGroup = false;
        for (var itemObj of this.data.items) {
            var foundGroupValue: boolean = false;
            itemObj["calendar"] = itemObj[this.calendarConfig.columnView.groupValue]
            if (itemObj.calendar) {
                for (let datagroupValue of this.calendarConfig.columnView.groups) {
                    if (itemObj.calendar == datagroupValue) {
                        if (groupLabels.indexOf(datagroupValue) == -1) {
                            groupLabels.push(datagroupValue);
                        }
                        foundGroupValue = true;
                    }
                }
            }

            if (foundGroupValue === false) {
                addOtherGroup = true;
            }
        }

        if (!this.data.items.length) {
            groupLabels = this.calendarConfig.columnView.groups;
        } else {
            // wegen Reihenfolge nochmal neu zusammenbauen!! #24202
            let collectedLabels = groupLabels;
            groupLabels = [];
            for (let label of this.calendarConfig.columnView.groups) {
                if (collectedLabels.indexOf(label) != -1) {
                    groupLabels.push(label);
                }
            }
        }

        if (addOtherGroup && this.showDivSubGroup) {
            groupLabels.push(otherGroupsTitle);
        }

        return groupLabels;
    }
    
    getWeekNumberLabelFIXED(targetDate: Date): string {
        // wenn der 1.1. ein Montag ist, dann z�hlt Dojo KW0
        // mit der Methode fixen wir das

        if (targetDate == null || !targetDate.getFullYear) return "";

        let copyDate = new Date(targetDate.valueOf());
        let weekCounter = 1;

        let startDate = new Date(copyDate.getFullYear(), 0, 1); // 1.1. des selben Jahres

        // auf den letzten Tag der Woche setzen:
        let dayOfWeek = startDate.getDay(); // Sonntag = 0, Montag = 1 ...
        if (dayOfWeek != 0) {
            // 0 - 0
            // 1 - +6 (Montag: 6 Tage dazuz�hlen)
            // 2 - +5 (Dienstag: 5 Tage dazuz�hlen)
            // ....
            let additionValue = 7 - dayOfWeek;
            startDate.setDate(startDate.getDate() + additionValue); // jetzt steht start auf jeden Fall am ersten Sonntag im Jahr, und das ist KW 1
        }

        // target auch auf den letzten Tag der Woche setzen:
        dayOfWeek = copyDate.getDay(); // Sonntag = 0, Montag = 1 ...
        if (dayOfWeek != 0) {
            // 0 - 0
            // 1 - +6
            // 2 - +5
            // ....
            let additionValue = 7 - dayOfWeek;
            copyDate.setDate(copyDate.getDate() + additionValue); // Target ist jetzt auf den folgenden Sonntag gestellt
        }
        
        

        // das compareDate einen Tag nach hinten setzen. es darf nie gleich wie der 1.1. sein
        let compareDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);

        // immer 7 Tage dazuz�hlen, bis wir das target �berholt haben
        // Ausnahme: wenn das Datum nicht im selben Jahr wie der Sonntag liegt, dann ist es schon KW 1 des Folgejahres. Schleife �berspringen.
        while (compareDate.valueOf() < copyDate.valueOf() && copyDate.getFullYear() == compareDate.getFullYear()) {
            weekCounter++;
            compareDate = new Date(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate() + 7, 0, 0);

            if (weekCounter >= 999) break;
        }
        let weekNumber = weekCounter;

        return weekNumber.toString();
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // FIX: Weeknumberlabel ist 2024 FALSCH (f�ngt bei 0 an)
        // eigene Methode zur Berechnung �berschreiben...
        (this.matrixView as any).getWeekNumberLabel = this.getWeekNumberLabelFIXED;

        // wir verstecken die buttons by default
        //domClass.add(this.calendarButtons.domNode, "w3-hide");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }

      ////// Editing zeug aus main Properties, nicht auf morecoreCalendar abgestimmt-------------------------- not in use... yet ----------------START
    ////undoAll_button: HTMLButtonElement;
    ////saveChanges_button: HTMLButtonElement;
    ////lockEditing_Button_container: HTMLElement;
    ////lockEditing_Button: HTMLButtonElement;
    ////unlockEditing_Button_container: HTMLElement;
    ////unlockEditing_Button: HTMLButtonElement;
    ////itemEditChangesRegistry: Array<{ item: object }> = [];
    ////editToastUUID: Function = null;
    ////isEditingLocked: boolean = true;

    ////_onItemEditGesture_end(e: any /*custom event*/): void {

    ////    //console.log("items:: ", this.calendar.items);

    ////    if (e && e.item && e.source) {

    ////        if (this.itemEditChangesRegistry && this.itemEditChangesRegistry.length) {
    ////            var itemExists: boolean = false;

    ////            for (var i = 0; i < this.itemEditChangesRegistry.length; i++) {
    ////                var registryItem: { item: object } = this.itemEditChangesRegistry[i];

    ////                if (registryItem.item["id"] == e.item.id) {

    ////                    this.itemEditChangesRegistry[i].item = e.item;
    ////                    itemExists = true;
    ////                }
    ////            }

    ////            if (itemExists === false) {
    ////                this.itemEditChangesRegistry.push({ item: e.item })
    ////            }

    ////        } else if (this.itemEditChangesRegistry && this.itemEditChangesRegistry.length == 0) {
    ////            this.itemEditChangesRegistry.push({ item: e.item })
    ////        } else {
    ////            alert("itemEditChangesRegistry has no instance");
    ////        }
    ////    }

    ////    if (this.itemEditChangesRegistry.length > 0) {
    ////        topic.publish("mainProperties/disableCalButtons");
    ////    }


    ////    if (this.toaster.activeToasts.length) {
    ////        // timeout ist permanent
    ////    } else {
    ////        // eine Id f�r toast erstellen
    ////        this.editToastUUID = function () {
    ////            return "uuid-" + ((new Date).getTime().toString(16) + Math.floor(1E7 * Math.random()).toString(16));
    ////        }


    ////        this.toaster.addToast('Save changes?', '<i class="fa fa-2x fa-floppy-o" aria-hidden="true"></i>', {
    ////            buttons: [
    ////                {
    ////                    innerHTML: '<i class="fa fa-3x fa-undo" aria-hidden="true"></i>', callback: lang.hitch(this, function () {
    ////                        this._onClick_undoAll_button();
    ////                    })
    ////                },
    ////                {
    ////                    innerHTML: '<i class="fa fa-3x fa-floppy-o" aria-hidden="true"></i>', callback: lang.hitch(this, function () {
    ////                        this._onClick_saveChanges_button();
    ////                    })
    ////                },
    ////            ],
    ////            timeout: "permanent",
    ////            close: true,
    ////            ID: this.editToastUUID()
    ////        })
    ////    }

    ////    domAttr.remove(this.undoAll_button, "disabled");
    ////    domAttr.remove(this.saveChanges_button, "disabled");


    ////    // this below would set back the start- && endTime of the item to the state before editing, while the editing itself is enabled
    ////    //e.item.startTime = e.source._editStartTimeSave;
    ////    //e.item.endTime = e.source._editEndTimeSave;
    ////}

    ////_onClick_saveChanges_button(): void {


    ////    this.toaster._removeAllToasts();

    ////    var data: { changes: Array<{ item: object }> } = { changes: this.itemEditChangesRegistry };

    ////    ////wir m�ssen dates to iso strings konvertiern, damit unsdie TZ nicht dazwischen spuckt
    ////    for (let obj of this.itemEditChangesRegistry) {

    ////        obj["item"]["startTime"] = this.toStringISO(obj["item"]["startTime"]);
    ////        obj["item"]["endTime"] = this.toStringISO(obj["item"]["endTime"]);

    ////    }


    ////    console.log("UPDATE CHANGES:: ", data);

    ////    this.RequestManager.post(
    ////        window.appRoot + "Calendar/SaveChanges",
    ////        {
    ////            "jsonData": JSON.stringify(data)
    ////        },
    ////        lang.hitch(this, "_onUpdateItemChanges_Response"),
    ////        lang.hitch(this, function (err) { // errorCallback
    ////            if (err && err["Message"] != "success") {
    ////                alert("ERROR beim UpdateItemChanges: " + err["Message"]);
    ////                console.log(err);
    ////                this.StandbyStop();
    ////                domAttr.remove(this.undoAll_button, "disabled");
    ////                domAttr.remove(this.saveChanges_button, "disabled");
    ////            }
    ////        })
    ////    );

    ////    topic.publish("mainProperties/enableCalButtons");
    ////    domAttr.set(this.undoAll_button, "disabled", true);
    ////    domAttr.set(this.saveChanges_button, "disabled", true);
    ////}

    ////_onClick_undoAll_button(): void {


    ////    this.toaster._removeAllToasts();


    ////    if (this._isEditingEnabled) {
    ////        this._onGetFilterData_Response(this.lastGetFilterDataReponse);
    ////    } else if (!this._isEditingEnabled) {
    ////        alert("Editing is not enabled. You shouldnt even see this button");
    ////    }

    ////    topic.publish("mainProperties/enableCalButtons");
    ////    this.itemEditChangesRegistry = [];
    ////    domAttr.set(this.undoAll_button, "disabled", true);
    ////    domAttr.set(this.saveChanges_button, "disabled", true);

    ////}

    ////// eigene Funktion f�r das schrieben
    ////toStringISO(date: Date): string {

    ////    if (date && Object.prototype.toString.call(date) === "[object Date]") {

    ////        if (isNaN(date.getFullYear())) {
    ////            return null;
    ////        }

    ////        let day = ("0" + date.getDate()).slice(-2); //DD
    ////        let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
    ////        let year = date.getFullYear() //YYYY
    ////        let hours = ("0" + date.getHours()).slice(-2); // HH
    ////        let min = ("0" + date.getMinutes()).slice(-2);  // mm
    ////        let sec = ("0" + date.getSeconds()).slice(-2); // ss

    ////        // YYYY-MM-DDTHH:mm:ss
    ////        let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
    ////        return ISOString;
    ////    }

    ////    return null;
    ////}

    ////_onUpdateItemChanges_Response(response: any): void {

    ////    topic.publish("mainProperties/enableCalButtons");
    ////    if (response == "success") {

    ////        this.itemEditChangesRegistry = [];
    ////        this.loadCalendarData(this.calendar._timeInterval[0], this.calendar._timeInterval[1]);

    ////    } else {
    ////        console.log("Something went wrong: response //", response, "//, your chnages are not saved");
    ////    }


    ////}

    ////// Editing -------------------------- not in use... yet ------------END


}

export default mdsWidget(moreCoreCalendar);